export const SCREEN_LG = 992;
